import { useMediaQuery, useTheme } from '@mui/material'
import { Theme } from '@mui/material/styles'

import { BreakpointName } from '@/types/mui'

const useBreakpointName = (): BreakpointName | null => {
  const theme = useTheme<Theme>()

  const breakpoints: Record<BreakpointName, boolean> = {
    xs: useMediaQuery(theme.breakpoints.only('xs')),
    sm: useMediaQuery(theme.breakpoints.only('sm')),
    md: useMediaQuery(theme.breakpoints.only('md')),
    lg: useMediaQuery(theme.breakpoints.only('lg')),
    xl: useMediaQuery(theme.breakpoints.only('xl')),
  }

  const breakpointName = (
    Object.entries(breakpoints) as [BreakpointName, boolean][]
  ).reduce<BreakpointName | null>(
    (acc, [name, matches]) => (matches ? name : acc),
    null
  )

  return breakpointName
}

export default useBreakpointName
